import { appEventBus as e } from "../../../../web/utils/appEventBus/appEventBus.js";
import { AppEvents as s } from "../../../../web/utils/appEventBus/eventMap.js";
const t = [500], r = (r2) => {
  r2.interceptors.response.use((e2) => e2, async (r3) => {
    var _a;
    const n = (_a = r3.response) == null ? void 0 : _a.status;
    return t.includes(n) && e.emit(s.InternalServerErrorEvent, true), Promise.reject(r3);
  });
};
export {
  r as setupServerErrorInterceptor
};
//# sourceMappingURL=serverErrorInterceptor.js.map
